export const COUNSELING_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    status: true,
    title: "",
    title_text_color: "#000000",
    sub_title: "",
    sub_title_text_color: "#000000",
    cta_text: "Get Started",
    cta_text_color: "#FFFFFF",
    cta_button_background_color: "#000000",
    cta_button_icon: "",
    cta_button_icon_alt: "Get Started",
    background_color: "#FFFFFF",
  },

  COUNSELING_FIELDS_CONFIG: [
    {
      fieldName: "status",
      label: "Counseling Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable or disable counseling section",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "sub_title",
      label: "Sub Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Sub Title",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "sub_title_text_color",
      label: "Sub Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter sub title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "cta_text",
      label: "CTA Button Text",
      value: "Get Started",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA Button Text",
      required: false,
      defaultValue: "Get Started",
    },
    {
      fieldName: "cta_text_color",
      label: "CTA Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_button_background_color",
      label: "CTA Button Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button background color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "cta_button_icon",
      label: "CTA Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload CTA Button Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_button_icon_alt",
      label: "CTA Button Icon Alt Text",
      value: "Get Started",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for CTA button icon",
      required: false,
      defaultValue: "Get Started",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
  ],

  METADATA_FIELDS: [],
};

